import { SOUNDS, useAudio } from '@/context/AudioProvider'
import { useJackpot } from '@/context/JackpotProvider'
import { useSession } from '@/context/SessionProvider'
import { useSystem } from '@/context/SystemProvider'
import { Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

export const JackpotCounter = () => {
  const { account } = useSession()
  const jackpot = useJackpot()
  const getCurrentDateTime = useSystem((state) => state.getCurrentDateTime)
  const audio = useAudio()

  const [time, setTime] = useState(getCurrentDateTime().getTime())

  useEffect(() => {
    const interval = setInterval(() => setTime(getCurrentDateTime().getTime()), 1000)

    if (jackpot.state.players.find((player) => player.address === account?.injectiveAddress)) {
      audio.play(SOUNDS.TIMER_STARTS)
    }

    return () => {
      clearInterval(interval)
    }
  }, [])

  const secondsRemain = Math.max(Math.floor((jackpot.state.draw_timestamp - time - 6_000) / 1000), 0)
  const SECONDS_TO_DISPLAY_LIMIT = 60

  return (
    <Text fontWeight={700} fontSize={'3xl'}>
      00:{Math.min(SECONDS_TO_DISPLAY_LIMIT, secondsRemain).toString().padStart(2, '0')}
    </Text>
  )
}
